
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email-potrjen",
      function () {
        return require("private-next-pages/email-potrjen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/email-potrjen"])
      });
    }
  